import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormInputComponent, StringCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
  selector: 'empty-input-form',
  template: ``,
  styles: [':host{display:none}'],
  standalone: true,
})
export class EmptyInputFormComponent implements FormInputComponent<StringCustomFieldConfig> {
  readonly: boolean;
  config: StringCustomFieldConfig;
  formControl: FormControl;
}

